import clsx from 'clsx';
import React from 'react';

import { TimeSeriesItem } from '~/types/timeseries.types';
import { isBarBullish } from '~/utils/timeseries/time-series';

import styles from './OHLCPrice.module.scss';

export interface OHLCPriceProps {
  price: TimeSeriesItem;
  priceFormatter: (price: number) => string;
}

export const OHLCPrice = ({ price, priceFormatter }: OHLCPriceProps) => {
  const data = [
    { label: 'O', price: price.open },
    { label: 'H', price: price.high },
    { label: 'L', price: price.low },
    { label: 'C', price: price.close },
  ];

  const isBullish = isBarBullish(price);

  return (
    <div className={styles.ohlcPriceRoot} data-testid="ohlc-price">
      {data.map((d, i) => (
        <div className={styles.priceContainer} key={i}>
          <p className={styles.label}>{d.label}</p>
          <p
            className={clsx(styles.price, {
              [styles.bullish]: isBullish,
            })}
            data-testid={`ohlc-${d.label}-price`}
          >
            {priceFormatter(d.price)}
          </p>
        </div>
      ))}
    </div>
  );
};
